import I18n from 'I18n';
export const getIsUsingNodeJS = runtime => {
  return !!runtime.match(/^NODE/i);
};
export const getRuntimeOptionText = runtimeOption => {
  switch (runtimeOption) {
    case 'NODE16X':
      return I18n.text('automation-ui-action-features.action-features.custom-code.runtime-options.NODE16X');
    case 'NODE20X':
      return I18n.text('automation-ui-action-features.action-features.custom-code.runtime-options.NODE20X');
    case 'PYTHON36':
      return I18n.text('automation-ui-action-features.action-features.custom-code.runtime-options.PYTHON36');
    case 'PYTHON39':
      return I18n.text('automation-ui-action-features.action-features.custom-code.runtime-options.PYTHON39');
    default:
      {
        return runtimeOption;
      }
  }
};